import { render, staticRenderFns } from "./SchoolInfoDetails.vue?vue&type=template&id=c2cfb50e&scoped=true&"
import script from "./SchoolInfoDetails.vue?vue&type=script&lang=js&"
export * from "./SchoolInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfoDetails.vue?vue&type=style&index=0&id=c2cfb50e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cfb50e",
  null
  
)

export default component.exports